<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" thankyou :title="$t('Wizard completato')">
    <div class="pf-v6-u-text-align-center">
      <div>
        <pf-icon status="success" size="xl">
          <check-icon />
        </pf-icon>
        <pf-title h="2">{{ $t('Offerta creata') }}</pf-title>
      </div>
      <div class="pf-v6-u-mt-lg">
        <p v-if="wizard.action == 'mailme'">
          {{ $t("Controlla la tua mail, ti abbiamo inviato il PDF dell'offerta") }}
        </p>
        <p v-else-if="wizard.action == 'mailcustomer'">
          {{ $t("Abbiamo inviato l'offerta alla mail del cliente da te scelto.") }}
        </p>

        <p v-if="wizard.offer?.id">
          <a target="_blank" :href="`/rest/offer-pdf/${wizard.offer.id}`" ref="downloadRef">
            <file-pdf-icon /> {{ $t("Clicca qui per scaricare il PDF dell'offerta") }}
          </a>
        </p>
      </div>
      <div class="pf-v6-u-mt-lg">
        <pf-title h="3" class="pf-v6-u-mb-md">{{ $t('Come vuoi procedere ora?') }}</pf-title>

        <granted-link :to="{ name: 'offers' }">
          {{ $t('Vai alle offerte') }}
        </granted-link>

        <granted-link
          v-if="wizard.offer?.id && wizard.canConfirmOffer"
          type="primary"
          :to="{ name: 'confirm_offer', params: { id: wizard.offer.id } }"
          class="pf-v6-u-ml-md"
        >
          {{ $t('Conferma ordine') }}
        </granted-link>
      </div>
    </div>
  </wizard-form>
</template>

<script lang="ts" setup>
import { useTemplateRef, watch } from 'vue';
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '@/wizard';
import WizardForm from '../wizard-form.vue';
import CheckIcon from '@vue-patternfly/icons/check-icon';
import FilePdfIcon from '@vue-patternfly/icons/file-pdf-icon';
import GrantedLink from '../../granted-link.vue';

defineOptions({
  name: 'WizardStepThankYou',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep();
defineExpose({
  isEnabled,
});

const download = useTemplateRef('downloadRef');

watch(
  () => download.value && hidden.value,
  () => {
    if (!hidden.value && wizard.action === 'pdf') {
      download.value?.click();
    }
  },
);
</script>
